import styled, { css } from "styled-components";
import { getLocale } from "react-i18nify";

import device from "src/styles/device";
import font from "src/styles/font";

import {
  TextField,
  Grid,
  Box,
  IconButton,
  FormControlLabel,
  InputAdornment,
  Checkbox,
} from "@mui/material";

import Button from "src/components/core/Button";

import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

import useModal from "src/hooks/useModal";
import useDeviceSize from "src/hooks/useDeviceSize";
import { convertPrice } from "src/common";

import ModalAddition from "src/modules/quotation-draft/CreateQuoDraft/AdditionModal";
import EditSheet from "src/modules/quotation-draft/CreateQuoDraft/ProductSheet/EditSheet";

const WrapperGrid = styled.div`
  width: 100%;
  /* margin-top: 24px; */
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  border-radius: 24px;
  background-color: var(--white-color);
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1); */

  ::-webkit-scrollbar {
    width: 5px;
    height: 7px;
    display: none;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--grey-color);
    border-radius: 100px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--grey-color);
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }

  @media ${device.tabletL} {
    padding-bottom: 0;
    margin-bottom: 24px;

    ${({ empty }) =>
      empty
        ? css`
            border-radius: 24px 24px 0 0;
            box-shadow: none;
          `
        : css`
            border-radius: 24px;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
          `}
  }
`;

const TextDetail = styled(Box)`
  width: 100%;
  color: ${({ color }) =>
    color === "grey" ? "var(--darkgrey-color)" : "var(--secondary-color)"};
  font-size: ${font.size.sm};
  font-weight: 400;
  margin-bottom: 8px;

  :last-child {
    margin-bottom: 0;
  }

  ${({ nowrap }) =>
    nowrap
      ? css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `
      : css`
          white-space: pre-line;
          word-break: break-word;
        `}/* @media ${device.tabletL} {
    font-size: ${font.size.sm};
  } */
`;

const OtherDataGrid = ({
  formErrors,
  formData,
  onChange,
  dataProductList,
  dataServiceType,
  onAppendElement, // add default product
  onRemoveElement,
  initialConfirm,
  setConfirmInfo,
}) => {
  const [deviceWidth] = useDeviceSize();

  const { getModalState, open, close } = useModal();

  const handleOnRemove = (index) => {
    if (formData.other_list.length < 2) {
      onRemoveElement(index);
      onAppendElement();
      onChange("", "", "");
    } else {
      onRemoveElement(index);
    }
  };

  return (
    <>
      <WrapperGrid
        empty={
          formData?.other_list[0]?.other_code === "" &&
          formData?.other_list[0]?.other_text === ""
        }
      >
        <Grid
          container
          sx={{
            m: 0,
            width: "100%",
            minWidth: {
              xs: "860px",
              md: "unset",
            },
          }}
        >
          {/* Header */}
          <Grid
            item
            xs={12}
            sx={{
              px: { lg: 5, xs: 3 },
              py: 2,
              backgroundColor: "var(--darkwhite-color)",
              borderRadius: "24px 24px 0 0",
              fontSize: font.size.sm,
            }}
          >
            <Grid
              container
              columnSpacing={2}
              sx={{
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={2.2} md={2.5} sx={{ textAlign: "left" }}>
                รหัสสินค้า
              </Grid>

              <Grid item xs={2.2} md={2.5} sx={{ textAlign: "left" }}>
                สินค้า
              </Grid>

              <Grid item xs={1.45} md={1.25}>
                จำนวน
              </Grid>

              <Grid item xs={1.45} md={1.3}>
                ราคาต่อหน่วย
              </Grid>

              <Grid item xs={1.45} md={1.25}>
                หน่วย
              </Grid>

              <Grid item xs={1.45} md={1.25}>
                ส่วนลด
              </Grid>

              <Grid item xs={1.8} md={1.5}>
                ราคารวมทั้งหมด
              </Grid>
            </Grid>
          </Grid>

          {formData?.other_list?.length > 0 &&
            formData.other_list.map((product, index) => (
              <>
                {deviceWidth > 835 ? (
                  <>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        px: { lg: 5, xs: 3 },
                        py: 3,
                        fontSize: font.size.sm,
                        borderBottom: "1px solid var(--lightgrey-color)",
                      }}
                      key={`other-desktop-${index}`}
                    >
                      <Grid
                        container
                        columnSpacing={2}
                        sx={{
                          fontSize: font.size.md,
                          ".MuiAutocomplete-root": {
                            margin: 0,
                          },
                          ".MuiTextField-root": {
                            borderRadius: "24px",
                          },
                          ".MuiOutlinedInput-root": {
                            borderRadius: "24px",
                          },
                          ".MuiOutlinedInput-input": {
                            py: "10px",
                            textAlign: "center",
                          },
                          ".MuiInputBase-inputMultiline": {
                            p: 0,
                            textAlign: "left",
                          },
                          ".MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":
                            {
                              px: 0,
                            },
                        }}
                      >
                        <Grid item xs={2.5}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            multiline
                            // maxRows={2}
                            sx={{
                              ".MuiOutlinedInput-input": {
                                textAlign: "left",
                              },
                            }}
                            placeholder="เพิ่มรหัสสินค้า"
                            value={product?.other_code}
                            onChange={(e) => {
                              onChange(e, `other_list.${index}.other_code`);
                            }}
                            error={
                              !!formErrors[`other_list[${index}].other_code`]
                            }
                          />
                        </Grid>

                        <Grid item xs={2.5}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            multiline
                            // maxRows={2}
                            sx={{
                              ".MuiOutlinedInput-input": {
                                textAlign: "left",
                              },
                            }}
                            placeholder="เพิ่มสินค้า"
                            value={product?.other_text}
                            onChange={(e) => {
                              onChange(e, `other_list.${index}.other_text`);
                            }}
                            error={
                              !!formErrors[`other_list[${index}].other_text`]
                            }
                          />
                        </Grid>

                        <Grid item xs={1.25}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            sx={{
                              pt: "9px",
                            }}
                            value={product?.volume}
                            onChange={(e) => {
                              if (e.target.value * 0 === 0)
                                onChange(
                                  null,
                                  `other_list.${index}.volume`,
                                  e.target.value,
                                );
                            }}
                            onBlur={(e) => {
                              if (e.target.value * 0 === 0)
                                onChange(
                                  null,
                                  `other_list.${index}.volume`,
                                  parseFloat(e.target.value) || 0,
                                );
                            }}
                            // error={
                            //   !!formErrors[
                            //     `other_list[${index}].volume`
                            //   ]
                            // }
                            error={
                              product?.other_code !== "" &&
                              product?.other_text !== "" &&
                              !product?.volume
                            }
                          />
                        </Grid>

                        <Grid item xs={1.3}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            sx={{
                              pt: "9px",
                              ".MuiInputAdornment-root": {
                                position: "absolute",
                                left: "14px",
                              },
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  ฿
                                </InputAdornment>
                              ),
                            }}
                            value={product?.price}
                            onChange={(e) => {
                              if (e.target.value * 0 === 0)
                                onChange(
                                  null,
                                  `other_list.${index}.price`,
                                  e.target.value,
                                );
                            }}
                            onBlur={(e) => {
                              if (e.target.value * 0 === 0)
                                onChange(
                                  null,
                                  `other_list.${index}.price`,
                                  parseFloat(e.target.value) || 0,
                                );
                            }}
                            // error={
                            //   !!formErrors[`other_list[${index}].price`]
                            // }
                            error={
                              product?.other_code !== "" &&
                              product?.other_text !== "" &&
                              !product?.price
                            }
                          />
                        </Grid>

                        <Grid item xs={1.3}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            sx={{
                              pt: "9px",
                            }}
                            placeholder="หน่วย"
                            value={product?.other_unit}
                            onChange={(e) => {
                              onChange(e, `other_list.${index}.other_unit`);
                            }}
                            // error={
                            //   !!formErrors[
                            //     `other_list[${index}].other_unit`
                            //   ]
                            // }
                            error={
                              product?.other_code !== "" &&
                              product?.other_text !== "" &&
                              !product?.other_unit
                            }
                          />
                        </Grid>

                        <Grid item xs={1.25}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            sx={{
                              pt: "9px",
                              ".MuiInputAdornment-root": {
                                position: "absolute",
                                left: "14px",
                              },
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  ฿
                                </InputAdornment>
                              ),
                            }}
                            value={product?.discount}
                            onChange={(e) => {
                              if (e.target.value * 0 === 0)
                                onChange(
                                  null,
                                  `other_list.${index}.discount`,
                                  e.target.value,
                                );
                            }}
                            onBlur={(e) => {
                              if (e.target.value * 0 === 0)
                                onChange(
                                  null,
                                  `other_list.${index}.discount`,
                                  parseFloat(e.target.value) || 0,
                                );
                            }}
                            error={
                              !!formErrors[`other_list[${index}].discount`]
                            }
                          />
                        </Grid>

                        <Grid item xs={1.5}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            sx={{
                              pt: "9px",
                              ".MuiInputAdornment-root": {
                                position: "absolute",
                                left: "14px",
                              },
                            }}
                            InputProps={{
                              readOnly: true,
                              startAdornment: (
                                <InputAdornment position="start">
                                  ฿
                                </InputAdornment>
                              ),
                            }}
                            value={product?.total}
                          />
                        </Grid>

                        <Grid item xs={0.4} sx={{ position: "relative" }}>
                          <IconButton
                            aria-label="delete"
                            // disabled={formData?.other_list?.length < 2}
                            disabled={
                              formData?.other_list?.length < 2 &&
                              !product.other_code &&
                              !product.other_text &&
                              !product.other_unit
                            }
                            onClick={() => {
                              if (
                                !!product.other_code ||
                                !!product.other_text ||
                                !!product.other_unit
                              ) {
                                setConfirmInfo((info) => ({
                                  ...info,
                                  visible: true,
                                  title:
                                    getLocale() === "th"
                                      ? `คุณต้องการลบสินค้าใช่หรือไม่`
                                      : `คุณต้องการลบสินค้าใช่หรือไม่`,
                                  confirmFunc: () => {
                                    handleOnRemove(index);
                                    setConfirmInfo(initialConfirm);
                                  },
                                }));
                              } else {
                                onRemoveElement(index);
                              }
                            }}
                            sx={{
                              position: "absolute",
                              right: {
                                xs: "-70%",
                                lg: "-40%",
                              },
                              top: "10px",
                              // top: "50%",
                              // transform: "translate(-40%, -65%);",
                              ":disabled": {
                                ".MuiSvgIcon-root": {
                                  color: "var(--darkgrey-color)",
                                },
                              },
                            }}
                          >
                            <DeleteOutlineIcon
                              sx={{ color: "var(--primary-color)" }}
                            />
                          </IconButton>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 2, textAlign: "left" }}>
                          <FormControlLabel
                            label="เพิ่มรายละเอียด"
                            sx={{
                              color: "var(--secondary-color)",
                              fontSize: font.size.sm,
                              fontWeight: 400,
                            }}
                            control={
                              <Checkbox
                                sx={{
                                  ":hover": {
                                    ".MuiSvgIcon-root": {
                                      color: "var(--primary-color)",
                                    },
                                  },
                                }}
                                icon={
                                  <RadioButtonUncheckedIcon
                                    sx={{ color: "var(--lightgrey-color)" }}
                                  />
                                }
                                checkedIcon={
                                  <RadioButtonCheckedIcon
                                    sx={{ color: "var(--primary-color)" }}
                                  />
                                }
                                checked={
                                  product?.description !== "" ? true : false
                                }
                                disabled={
                                  product?.description !== "" ||
                                  (product?.other_code === "" &&
                                    product?.other_text === "")
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  open(
                                    `other_list.${index}.description.add-other-descripition-modal`,
                                  );
                                }}
                              />
                            }
                          />
                        </Grid>

                        {product?.description !== "" ? (
                          <>
                            <Grid item xs={12} sx={{ mb: 1 }}>
                              <Button
                                variant="text"
                                sx={{
                                  px: 3,
                                  py: 1,
                                  borderRadius: 3,
                                }}
                                onClick={() => {
                                  open(
                                    `other_list.${index}.description.add-other-descripition-modal`,
                                    true,
                                  );
                                }}
                              >
                                แนะนำรายละเอียด
                              </Button>
                            </Grid>

                            <Grid item xs={12}>
                              <TextField
                                variant="outlined"
                                multiline
                                fullWidth
                                sx={{
                                  ".MuiOutlinedInput-root": {
                                    p: 2,
                                  },
                                  ".MuiOutlinedInput-input": {
                                    py: 0,
                                    lineHeight: 1.8,
                                    textAlign: "left",
                                  },
                                }}
                                value={product?.description}
                                onChange={(e) => {
                                  onChange(
                                    e,
                                    `other_list.${index}.description`,
                                  );
                                }}
                                error={
                                  !!formErrors[
                                    `other_list[${index}].description`
                                  ]
                                }
                              />
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                    </Grid>
                  </>
                ) : product?.other_code !== "" && product?.other_text !== "" ? (
                  <>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        px: 3,
                        pt: 2,
                        pb: 3,
                        fontSize: font.size.sm,
                        borderBottom: "1px solid var(--lightgrey-color)",
                        ":last-child": {
                          borderBottom: "none",
                        },
                      }}
                      key={`other-${index}`}
                    >
                      <Grid
                        container
                        columnSpacing={{ xs: 2, lg: 4 }}
                        sx={{
                          fontSize: font.size.md,
                          ".MuiAutocomplete-root": {
                            margin: 0,
                          },
                          ".MuiTextField-root": {
                            borderRadius: "24px",
                          },
                          ".MuiOutlinedInput-root": {
                            borderRadius: "24px",
                          },
                          ".MuiOutlinedInput-input": {
                            py: "10px",
                            fontSize: font.size.sm,
                            textAlign: "center",
                          },
                          ".MuiInputBase-inputMultiline": {
                            p: 0,
                            textAlign: "left",
                          },
                          ".MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":
                            {
                              px: 0,
                            },
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          container
                          columnSpacing={2}
                          onClick={() => {
                            open(
                              `other_list.${index}.other.edit-other-detail-modal`,
                            );
                          }}
                        >
                          <Grid item xs={2.2}>
                            <TextDetail sx={{ mt: 1 }}>
                              {product?.other_code}
                            </TextDetail>
                          </Grid>

                          <Grid item xs={2.2}>
                            <TextDetail sx={{ mt: 1 }}>
                              {product?.other_text}
                            </TextDetail>
                          </Grid>

                          <Grid item xs={1.45}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                              value={product?.volume}
                            />
                          </Grid>

                          <Grid item xs={1.45}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              sx={{
                                ".MuiInputAdornment-root": {
                                  position: "absolute",
                                  left: "14px",
                                },
                              }}
                              InputProps={{
                                readOnly: true,
                                // startAdornment: (
                                //   <InputAdornment position="start">
                                //     ฿
                                //   </InputAdornment>
                                // ),
                              }}
                              value={convertPrice(product?.price)}
                            />
                          </Grid>

                          <Grid item xs={1.45}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                readOnly: true,
                              }}
                              value={product?.other_unit}
                            />
                          </Grid>

                          <Grid item xs={1.45}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              sx={{
                                ".MuiOutlinedInput-root": {
                                  pl: 0,
                                },
                                ".MuiInputAdornment-root": {
                                  position: "absolute",
                                  left: "14px",
                                },
                              }}
                              InputProps={{
                                readOnly: true,
                                // startAdornment: (
                                //   <InputAdornment position="start">
                                //     ฿
                                //   </InputAdornment>
                                // ),
                              }}
                              value={convertPrice(product?.discount)}
                            />
                          </Grid>

                          <Grid item xs={1.8}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              sx={{
                                ".MuiInputAdornment-root": {
                                  position: "absolute",
                                  left: "14px",
                                },
                              }}
                              InputProps={{
                                readOnly: true,
                                // startAdornment: (
                                //   <InputAdornment position="start">
                                //     ฿
                                //   </InputAdornment>
                                // ),
                              }}
                              value={convertPrice(product?.total)}
                            />
                          </Grid>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 1, textAlign: "left" }}>
                          <FormControlLabel
                            label="เพิ่มรายละเอียด"
                            sx={{
                              color: "var(--secondary-color)",
                              fontSize: font.size.sm,
                              fontWeight: 400,
                            }}
                            control={
                              <Checkbox
                                sx={{
                                  ":hover": {
                                    ".MuiSvgIcon-root": {
                                      color: "var(--primary-color)",
                                    },
                                  },
                                }}
                                icon={
                                  <RadioButtonUncheckedIcon
                                    sx={{ color: "var(--lightgrey-color)" }}
                                  />
                                }
                                checkedIcon={
                                  <RadioButtonCheckedIcon
                                    sx={{ color: "var(--primary-color)" }}
                                  />
                                }
                                checked={
                                  product?.description !== "" ? true : false
                                }
                                disabled={
                                  product?.description !== "" ||
                                  (product?.other_code === "" &&
                                    product?.other_text === "")
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  open(
                                    `other_list.${index}.description.add-other-descripition-modal`,
                                  );
                                }}
                              />
                            }
                          />
                        </Grid>

                        {product?.description !== "" ? (
                          <>
                            <Grid item xs={12} sx={{ mt: 1 }}>
                              <TextField
                                variant="outlined"
                                multiline
                                fullWidth
                                sx={{
                                  ".MuiOutlinedInput-root": {
                                    p: 2,
                                  },
                                  ".MuiOutlinedInput-input": {
                                    py: 0,
                                    lineHeight: 1.8,
                                    textAlign: "left",
                                  },
                                }}
                                value={product?.description}
                                inputProps={{
                                  readOnly: true,
                                }}
                                onClick={() => {
                                  open(
                                    `other_list.${index}.description.add-other-descripition-modal`,
                                    true,
                                  );
                                }}
                              />
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                    </Grid>
                  </>
                ) : null}

                {/* edit tablet/mobile service */}
                <EditSheet
                  docType="other"
                  quoItemDetail={product}
                  dataProductList={dataProductList}
                  dataServiceType={dataServiceType}
                  isOpen={
                    getModalState(
                      `other_list.${index}.other.edit-other-detail-modal`,
                    )?.isOpen
                  }
                  onClose={() =>
                    close(`other_list.${index}.other.edit-other-detail-modal`)
                  }
                  onSubmit={(val) => {
                    onChange(null, `other_list.${index}.edit.other`, val);
                  }}
                  onRemoveElement={() => {
                    setConfirmInfo((info) => ({
                      ...info,
                      visible: true,
                      title:
                        getLocale() === "th"
                          ? `คุณต้องการลบสินค้าใช่หรือไม่`
                          : `คุณต้องการลบสินค้าใช่หรือไม่`,
                      confirmFunc: () => {
                        handleOnRemove(index);
                        close(
                          `other_list.${index}.other.edit-other-detail-modal`,
                        );
                        setConfirmInfo(initialConfirm);
                      },
                    }));
                  }}
                  // isRemoveDisabled={formData.other_list?.length <= 1}
                  isRemoveDisabled={false}
                />

                {/* add description */}
                <ModalAddition
                  type="desc"
                  descData={product?.description}
                  docType="other"
                  isOpen={
                    getModalState(
                      `other_list.${index}.description.add-other-descripition-modal`,
                    )?.isOpen
                  }
                  isEdit={
                    getModalState(
                      `other_list.${index}.description.add-other-descripition-modal`,
                    )?.isEdit
                  }
                  onClose={() =>
                    close(
                      `other_list.${index}.description.add-other-descripition-modal`,
                    )
                  }
                  onSubmit={(val) => {
                    onChange(null, `other_list.${index}.description`, val);
                    close(
                      `other_list.${index}.description.add-other-descripition-modal`,
                    );
                  }}
                />
              </>
            ))}

          {/* Add product */}
          {deviceWidth > 835 ? (
            <Grid
              item
              xs={12}
              sx={{
                px: { lg: 5, xs: 3 },
                pt: 3,
                pb: 5,
                fontSize: font.size.sm,
              }}
            >
              <Button
                variant="text"
                startIcon={<AddIcon />}
                sx={{
                  px: 3,
                  py: 1,
                  borderRadius: 3,
                }}
                onClick={onAppendElement}
              >
                Add Other
              </Button>
            </Grid>
          ) : null}
        </Grid>
      </WrapperGrid>
    </>
  );
};

export default OtherDataGrid;
